// extracted by mini-css-extract-plugin
export default {"burger":"nh8Wf","active":"cjULL"};